<template>
  <v-layout style="margin-top: 20px !important;" v-if="getIsGroupStoresLoading" justify-center>
    <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="mt-3 mb-3"
    />
  </v-layout>
  <v-layout v-else>
    <v-flex row xs12 sm10 offset-sm1>
    <div class="ml-2 mt-2 text-sm">
      <v-btn-toggle mandatory  :style="{ 'min-width': '50%', 'border-radius': '15px'}" >
        <v-btn
          flat
          :disabled="!hasDelivery"
          class="orderTypeSelect"
          :class="{ 'white--text': this.switchValue, 'selected': this.switchValue }"
          @change="onChange(true)" 
          large
          :style="{
              backgroundColor : this.switchValue ?  'var(--v-primary-base)' : 'white' ,
              'min-width': '50%',
              'min-height': '8vh',
              'border-radius': '15px 0px 0px 15px'
          }"
        >
          <div>{{ $vuetify.t('$vuetify.common.delivery') }}</div>
        </v-btn>
        <v-btn
          flat
          class="orderTypeSelect"
          :class="{ 'white--text': !this.switchValue, 'selected': true } "
          large
          @change="onChange(false)"
          :style="{
              backgroundColor : this.switchValue ? 'white' : 'var(--v-primary-base)',
              'min-width': '50%',
              'min-height': '8vh',
              'border-radius': '0px 15px 15px 0px'
          }"
        >
          <div>{{ $vuetify.t('$vuetify.common.pickup') }}</div>
        </v-btn>
        </v-btn-toggle>
      </div>
      <div v-show="((submittedAddress && deliveryAddress) || !switchValue)" class="mt-2 text-xs">
        <v-btn
          :class="{ 'mr-0': $vuetify.breakpoint.mdAndUp }"
          :loading="isFetchingLocation"
          color="primary"
          outline
          @click="toggleSort"
        >
          <v-icon left small>
            {{ isSortedByLocation ? 'sort_by_alpha' : 'location_on' }}
          </v-icon>
          {{ isSortedByLocation ? $vuetify.t('$vuetify.common.sortByAlpha') : $vuetify.t('$vuetify.common.sortByDistance') }}
        </v-btn>

        <!-- <v-btn v-if="!!maxDistance"
          :class="{ 'mr-0': $vuetify.breakpoint.mdAndUp }"
          color="primary"
          @click="withinDeliveryRange = !withinDeliveryRange"
          outline
        >
          <v-icon left small>
            local_shipping
          </v-icon>
          {{ withinDeliveryRange ? 'Show all stores' :' Hide out of range stores' }}
        </v-btn> -->
      </div>
      <div 
        v-show="hasDelivery"
        style="background-color: white; border: 1px solid var(--v-primary-base);
          border-radius: 32px;
          padding:10px;
          overflow: hidden;
          white-space: nowrap;
          margin-top: 2vh;
          margin-bottom: 2vh;
          width: 75%;
          margin-left: auto;
          margin-right: auto;
        "
        v-if="switchValue"
        >
      <div v-show="hasDelivery" id="autocompleteContainer">
        <vuetify-google-autocomplete
          id="map"
          ref="googleAddress"
          class="mx-2"
          append-icon="search"
          :placeholder="$vuetify.t('$vuetify.cart.enterYourAddress')"
          v-on:placechanged="parseAddressData"
          :country="getStoreCountryCode || 'CA'"
          clearable
          clearIcon="clear"
          v-model="deliveryAddress"
          :error="hasAddressError"
          autocomplete="none"
          v-on:change="addressChange"
        />
      </div>
      </div>
      <v-layout v-if="stores && stores.length && ((submittedAddress && deliveryAddress) || !switchValue)" row wrap grid-list-md class="sticky-parent mb-5">
        <v-flex v-for="(store, index) in stores" :key="store.code" xs12 sm6 md4 class="hover-animation-container pa-2">
          <v-card flat @click.self="goToStore(store, index)" :style="{backgroundColor: '#FFFFFF'}" class="pointer pa-3" style="height: 100%">
            <div class="groupStoreLocationDetails">
              <div v-if="validStores[index] && switchValue" :style="{color: '#4CAF50', marginBottom: '1vh'}" >
                <h5>{{ $vuetify.t('$vuetify.common.availableToDeliver') }}</h5>
              </div>

              <div v-if="!validStores[index] && switchValue" :style="{color: '#AAAAAA', marginBottom: '1vh'}" >
                <h5>{{ $vuetify.t('$vuetify.common.notAvailableForDelivery') }}</h5>
              </div>
              <StoreDetails :store="store" />

              <div v-if="!testStore(store) && supportsOffHourOrders(store)" class="extraAvailableDetails green--text">
                {{$vuetify.t('$vuetify.cart.offHourOrderingMaybeAllowed')}}
              </div>
            </div>

            <div id="orderNowButton">
              <v-btn round outline color="primary" @click="goToStore(store, index)" style="">
                {{ $vuetify.t('$vuetify.common.orderNow') }}
              </v-btn>
            </div>

            <span v-if="isSortedByLocation" class="storeDistanceIndicator grey--text" >
              <v-icon color="grey" small>location_on</v-icon>
              <span class="caption">
                {{ storeDistanceText(store) }}
              </span>
            </span>
          </v-card>
        </v-flex>
      </v-layout>
      <h2 v-else-if="((submittedAddress || !switchValue) && deliveryAddress)" style="margin: 30px auto">
        No Stores found
      </h2>
    </v-flex>
  </v-layout>
</template>

<script>
  import get from "lodash/get";
  import isEmpty from "lodash/isEmpty";
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import { calculateDistance } from "@/services/util.service"
  import { parseDeliveryAddress, isNullOrEmpty } from "@/services/util.service"

  import StoreDetails from "@/components/StoreDetails"

  export default {
    components: { StoreDetails },

    data: () => ({
      switchValue: true,
      hasDelivery: false,
      isFetchingLocation: false,
      withinDeliveryRange: false,
      deliveryAddress: '',
      hasAddressError: false,
      validStores: [false, false, false],
      checkedStores: 3,
      submittedAddress: false,
      filteredStores: [],
      referrer: ''
    }),

    computed: {
      // maxDistance() {
      //   return (get(this.getGroup, 'settings.deliverySettings.deliveryDistanceInMeters', 0) || 100000) / 1000
      // },

      isSortedByLocation() {
        return this.getGroupStoresSort === 'location'
      },

      stores() {
        const sortByDistance = (a, b) => {
          if (this.calculateStoreDistance(a) < this.calculateStoreDistance(b)) { return -1 }
          if (this.calculateStoreDistance(a) > this.calculateStoreDistance(b)) { return 1 }
          return 0;
        }

        const sortByAlpha = (a, b) => {
          const textA = (a.name || a.shortName || '').toUpperCase()
          const textB = (b.name || b.shortName || '').toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        }

        const groupHasDelivery = () => {
          let hasDelivery = false
          this.getGroupStores.forEach(s => {
            if (s.storeId && s.groupId && s.deliverySupported) {
              hasDelivery = true
            }
          })
          return hasDelivery
        }

        this.hasDelivery = groupHasDelivery()
        if (!this.hasDelivery){
          this.switchValue = false
        }

        let stores = this.getGroupStores.filter(s => {
          if (this.switchValue) {
             return s.storeId && s.groupId && s.deliverySupported
          } else {
             return s.storeId && s.groupId && s.pickupSupported
          }
        })

        

        // if (this.withinDeliveryRange && this.maxDistance) {
        //   stores = stores.filter(s => this.calculateStoreDistance(s) <= this.maxDistance)
        // }

        return stores.sort(this.isSortedByLocation ? sortByDistance : sortByAlpha)
      },

      ...mapGetters([
        'getGroup',
        'getGroupStores',
        'getGroupStoresSort',
        'getIsGroupStoresLoading',
        'getDeviceCoordinates',
        'testStore',
        'doesStoreHaveSetting',
        'getStoreCountryCode',
        'getDeliveryAddress'
      ])
    },

    methods: {
      extractReferrer() {
        const urlParams = new URLSearchParams(window.location.search);
        this.referrer = urlParams.get('referrer') || '';
      },
      supportsOffHourOrders(store) {
        return this.doesStoreHaveSetting('allowOffHourPickup', false, store) || this.doesStoreHaveSetting('allowOffHourDelivery', false, store)
      },

      goToStore(store, index) {
        if (this.switchValue) {
          this.setOrderType('DELIVERY')
          if(!this.submittedAddress){
            this.setDeliveryAddress(null)
          }
        } else {
          this.submittedAddress = false
          this.setOrderType('PICKUP')
        }
        
        if (!this.switchValue || (index > this.checkedStores ? false : this.validStores[index])) {
          this.SET_CHECKOUT_INFO({
            ...this.getCheckoutInfo,
            unitNumber: null
          })
        } 
        const referrerParam = this.referrer ? { referrer: this.referrer } : {};
        localStorage.setItem('preventRouterLoop', 'true');
        this.$store.commit('SET_STORE', { store: store });
        this.$router.push({
          name: 'menu-selection',
          params: { gid: store.groupId, sid: store.storeId, restaurantSlug: store.slug, ...referrerParam },
          query: { ...this.$route.query, gid: store.groupId, direct: 'true' }
        })
        this.$store.dispatch('setStoreId', {
          gid: store.groupId,
          sid: store.storeId
        }).catch(error => {
          console.error('Error setting store ID:', error);
          this.$store.dispatch('showSnack', { 
            text: 'Error loading store information. Please try again.', 
            color: 'error' 
          });
        });
      },

      storeDistanceText(store) {
        const distanceKm = this.calculateStoreDistance(store);
        const isUS = store.country === 'US';

        if (isUS) {
          const distanceMi = Math.round((distanceKm * 0.621371 + Number.EPSILON) * 10) / 10;
          if (distanceMi < 1) {
            return '< 1 mi';
          } else if (distanceMi > 100) {
            return '> 100 mi';
          } else {
            return `${distanceMi} mi`;
          }
        } else {
          if (distanceKm < 1) {
            return '< 1 km';
          } else if (distanceKm > 100) {
            return '> 100 km';
          } else {
            return `${distanceKm} km`;
          }
        }
      },

      calculateStoreDistance(store) {
        const { gpsCoordinate = {} } = store || {}
        const { latitude, longitude } = gpsCoordinate
        const { latitude: deviceLatitude, longitude: deviceLongitude } = this.getDeviceCoordinates

        const distanceKms = calculateDistance(latitude, longitude, deviceLatitude, deviceLongitude)
        return Math.round((distanceKms + Number.EPSILON) * 10) / 10
      },
      clearDeliveryAddress() {
          this.setDeliveryAddress(null)
          this.deliveryAddress = null
          this.validStores = [false, false, false]
          this.submittedAddress = false
          this.hasAddressError = false
      },
      parseAddressData(addressData, placeResultData, id) {
        const { gid } = this.$route.params;
        this.submittedAddress = true
        this.hasAddressError = false
        if (!isEmpty(addressData)) {
          this.onSortByAddress(addressData.latitude, addressData.longitude).then(async () => {
            if (this.stores.length < 3){
              this.checkedStores = this.stores.length
            }
            for (let i = 0; i < this.checkedStores; i++) {
              const store = this.stores[i];
              const payload = parseDeliveryAddress(null, addressData, placeResultData);

              try {
                await this.$store.dispatch('setStoreId', {
                  gid: gid,
                  sid: store.storeId
                });

                const res = await this.$store.dispatch('validateDeliveryAddress', payload);

                if (!res.data.result[0].error) {
                  this.setDeliveryAddress({
                    address: payload,
                    result: placeResultData
                  });
                  this.validStores.splice(i, 1, true);
                }
              } catch (error) {
                  const payload = { text: '$vuetify.order.deliveryAddressMustBeInRange' ? this.$vuetify.t('$vuetify.order.deliveryAddressMustBeInRange') : 'error', color: 'error' }
                  this.$store.dispatch('showSnack', payload)
                  this.isFetchingLocation = false
                  this.clearDeliveryAddress()
              }
            }
          });
        } else if (this.getDeliveryAddress) {
          this.clearDeliveryAddress()
        }
      },

      addressChange(){
        if(!this.deliveryAddress){
          this.submittedAddress = false
        }
      },

        findMostValidProvider(providers) {
        if (!isNullOrEmpty(providers)) {
          this.SET_DELIVERY_PROVIDERS_DETAILS(providers)
          const mostValid = providers.find(_provider => _provider.valid)
          if (!!mostValid) {
            return true
          } else {
            return false
          }
        }
      },
      onSortByLocation(){
        this.isFetchingLocation = true

        return new Promise((resolve, reject) => {
          const success = (pos) => {
            const { coords = {} } = pos || {}
            const { latitude, longitude } = coords
            const deviceCoordinates = { latitude, longitude }
            this.setDeviceCoordinates(deviceCoordinates)
            this.setGroupStoresSort('location')
            this.isFetchingLocation = false
            resolve(true)
          }

          const error = (err) => {
            const { message } = err
            const payload = { text: message, color: 'error' }
            this.$store.dispatch('showSnack', payload)
            this.isFetchingLocation = false
            resolve(true)
          }

          const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          };

          navigator.geolocation.getCurrentPosition(success, error, options)
        })
      },
      onSortByAddress(latitude, longitude){
        this.isFetchingLocation = true
        return new Promise((resolve) => {
          const deviceCoordinates = { latitude, longitude }
          this.setDeviceCoordinates(deviceCoordinates)
            .then(() => this.setGroupStoresSort('location')
            .then(() => {
              this.isFetchingLocation = false
              resolve(true)
            }
          )).catch((err) => {
            if (err && err.message) {
              const { message } = err
              const payload = { text: message, color: 'error' }
              this.$store.dispatch('showSnack', payload)
            }
            this.isFetchingLocation = false
            resolve(true)
          })
        })
      },
      toggleSort() {
        if (this.isSortedByLocation) {
          return this.setGroupStoresSort('alpha')
        } else {
          return this.onSortByLocation()
        }
      },
      onChange(event){
        if(event){
          this.switchValue = true
          this.onSortByLocation()
        } else {
          this.switchValue = false
        }
      },
      setDeliveryProvider(newProvider, storeId) {
        let obj = this.getDeliveryProvider || {}
        obj[storeId] = newProvider
        this.SET_DELIVERY_PROVIDER(obj)
      },
      ...mapActions([ 'setGroupStoresSort', 'setDeviceCoordinates', 'setDeliveryAddress', 'setOrderType' ]),
      ...mapMutations([ 'SET_DELIVERY_PROVIDER', 'SET_DELIVERY_PROVIDERS_DETAILS', 'SET_CHECKOUT_INFO' ])
    },

    mounted() {
      if (!!this.stores) {
        if(this.stores.length == 1 &&  this.getGroupStores.length == 1) {
          this.goToStore(this.stores[0], 0)
        }
        this.onSortByLocation()
      }
    }
  }
</script>

<style>
  .groupStoreLocationDetails #storeName {
    font-size: var(--text-size-2);
    margin: 0px auto 5px;
  }
  .groupStoreLocationDetails a {
    font-size: var(--text-size-1);
    /* margin: 0px auto 5px; */
  }
</style>
<style scoped>
  .groupStoreLocationDetails {
    text-align: left;
  }

  .hover-animation-container .v-btn {
    position: absolute;
    left: calc(50% - (140px / 2));
    bottom: 5px;
  }

  .storeDistanceIndicator {
    position: absolute;
    top: 2px;
    right: 5px;
  }

  #orderNowButton {
    height: 36px;
    width: 100%;
    
    margin-top: 20px;
  }
  #orderNowButton .v-btn {
    font-size: calc(var(--text-size-1) * 1.2);
  }

  .orderTypeSelect {
    font-size: calc(var(--text-size-1) * 1.2);
    padding: 25px !important;
    width: 120px !important;
  }

  .v-switch {
  border-radius: 15px;
  width: 48px;
  height: 29px;
  top: -2px;
}
</style>